import React from 'react';

// Renderiza a resposta da IA (markdown simples) sem HTML cru:
// títulos (#), listas numeradas (1.), listas com marcador (-, *, •), **negrito**, *itálico* e parágrafos.

// "Passo 1 ... 2. ... 3. ..." numa linha só vira uma linha por passo
function separarPassosNaMesmaLinha(linha) {
  if (!/(^|\s)1[.)]\s.+\s2[.)]\s/.test(linha)) return [linha];
  return linha.split(/\s+(?=\d+[.)]\s)/);
}

function renderizarInline(texto, chaveBase) {
  const partes = [];
  const regex = /\*\*(.+?)\*\*|__(.+?)__|\*(?!\s)(.+?)\*/g;
  let ultimo = 0;
  let m;
  let i = 0;
  while ((m = regex.exec(texto)) !== null) {
    if (m.index > ultimo) partes.push(texto.slice(ultimo, m.index));
    if (m[1] || m[2]) partes.push(<strong key={`${chaveBase}-b${i++}`}>{m[1] || m[2]}</strong>);
    else partes.push(<em key={`${chaveBase}-i${i++}`}>{m[3]}</em>);
    ultimo = regex.lastIndex;
  }
  if (ultimo < texto.length) partes.push(texto.slice(ultimo));
  return partes;
}

function TextoFormatadoIA({ texto }) {
  const linhas = String(texto || '')
    .replace(/\r\n/g, '\n')
    .split('\n')
    .flatMap(separarPassosNaMesmaLinha);

  const blocos = [];
  let lista = null; // { tipo: 'ol' | 'ul', itens: [] }
  let paragrafo = [];

  const fecharParagrafo = () => {
    if (paragrafo.length) {
      blocos.push({ tipo: 'p', linhas: paragrafo });
      paragrafo = [];
    }
  };
  const fecharLista = () => {
    if (lista) {
      blocos.push(lista);
      lista = null;
    }
  };

  linhas.forEach(bruta => {
    const linha = bruta.trim();
    if (!linha) {
      fecharParagrafo();
      fecharLista();
      return;
    }

    const titulo = linha.match(/^#{1,6}\s+(.*)$/);
    const numerado = linha.match(/^(\d+)[.)]\s+(.*)$/);
    const marcador = linha.match(/^[-*•]\s+(.*)$/);

    if (titulo) {
      fecharParagrafo();
      fecharLista();
      blocos.push({ tipo: 'h', texto: titulo[1] });
    } else if (numerado || marcador) {
      fecharParagrafo();
      const tipo = numerado ? 'ol' : 'ul';
      if (!lista || lista.tipo !== tipo) {
        fecharLista();
        lista = { tipo, itens: [], inicio: numerado ? parseInt(numerado[1], 10) : 1 };
      }
      lista.itens.push(numerado ? numerado[2] : marcador[1]);
    } else if (lista && /^\s{2,}/.test(bruta)) {
      // continuação indentada de um item da lista
      lista.itens[lista.itens.length - 1] += ' ' + linha;
    } else {
      fecharLista();
      paragrafo.push(linha);
    }
  });
  fecharParagrafo();
  fecharLista();

  return (
    <div className="ia-texto-formatado">
      {blocos.map((b, idx) => {
        if (b.tipo === 'h') return <p key={idx} className="ia-texto-titulo"><strong>{renderizarInline(b.texto, idx)}</strong></p>;
        if (b.tipo === 'p') {
          return (
            <p key={idx}>
              {b.linhas.map((l, j) => (
                <React.Fragment key={j}>
                  {j > 0 && <br />}
                  {renderizarInline(l, `${idx}-${j}`)}
                </React.Fragment>
              ))}
            </p>
          );
        }
        const Tag = b.tipo;
        return (
          <Tag key={idx} start={b.tipo === 'ol' && b.inicio !== 1 ? b.inicio : undefined}>
            {b.itens.map((item, j) => <li key={j}>{renderizarInline(item, `${idx}-${j}`)}</li>)}
          </Tag>
        );
      })}
    </div>
  );
}

export default TextoFormatadoIA;
